import { render, staticRenderFns } from "./ValanceGroup.vue?vue&type=template&id=1ab96f58&scoped=true&"
import script from "./ValanceGroup.vue?vue&type=script&lang=ts&"
export * from "./ValanceGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ValanceGroup.vue?vue&type=style&index=0&id=1ab96f58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab96f58",
  null
  
)

export default component.exports